/* ==========================================================================
   KOLP — Global UI
   Header, mobile menu, announcement rotation, reveal-on-scroll, sticky CTA,
   size-guide modal, product gallery, newsletter, cookie banner.
   Depends on: kolp-core.js
   ========================================================================== */
(function () {
  'use strict';
  var KOLP = window.KOLP || {};
  var $ = KOLP.$, $$ = KOLP.$$;

  /* ---- header stuck state ------------------------------------------- */
  var header = $('.header');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-stuck', window.scrollY > 8);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---- mobile menu ------------------------------------------------- */
  var menu = $('.mobile-menu');
  var navToggle = $('.nav-toggle');
  if (menu && navToggle) {
    var release;
    var openMenu = function () {
      menu.classList.add('is-open');
      document.body.classList.add('no-scroll');
      navToggle.setAttribute('aria-expanded', 'true');
      release = KOLP.trapFocus(menu);
      var c = menu.querySelector('[data-menu-close]');
      c && c.focus();
    };
    var closeMenu = function () {
      menu.classList.remove('is-open');
      document.body.classList.remove('no-scroll');
      navToggle.setAttribute('aria-expanded', 'false');
      release && release();
      navToggle.focus();
    };
    navToggle.addEventListener('click', openMenu);
    $$('[data-menu-close]', menu).forEach(function (b) { b.addEventListener('click', closeMenu); });
    $$('a', menu).forEach(function (a) { a.addEventListener('click', closeMenu); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.classList.contains('is-open')) closeMenu();
    });
  }

  /* ---- announcement rotation ------------------------------------- */
  var track = $('.announcement__track');
  if (track) {
    var items = $$('.announcement__item', track);
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    items.forEach(function (it, i) { it.hidden = i !== 0; });
    if (items.length > 1 && !reduceMotion) {
      var idx = 0;
      var delay = Math.max(1500, parseInt(track.getAttribute('data-rotate'), 10) || 2000);
      setInterval(function () {
        items[idx].hidden = true;
        idx = (idx + 1) % items.length;
        items[idx].hidden = false;
      }, delay);
    }
  }

  /* ---- reveal on scroll ----------------------------------------- */
  var reveals = $$('.reveal');
  if (reveals.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---- sticky mobile CTA --------------------------------------- */
  var sticky = $('[data-sticky-cta-bar]');
  var anchor = $('[data-purchase-section]');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    var packLabel = sticky.querySelector('[data-sticky-pack]');
    var priceLabel = sticky.querySelector('[data-bb-total]');
    var so = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        // show sticky only after the purchase section has scrolled past
        var show = en.boundingClientRect.top < 0 && !en.isIntersecting;
        sticky.classList.toggle('is-visible', show);
        document.documentElement.style.setProperty('--sticky-cta-height', show ? sticky.offsetHeight + 'px' : '0px');
      });
    }, { threshold: 0, rootMargin: '-80px 0px 0px 0px' });
    so.observe(anchor);

    KOLP.bus.on('builder:update', function (d) {
      /* <product-form> emits this too, so the sticky price follows a variant
         change — but it sends the QUANTITY as `pack`, which is not a pack tier.
         Reading it as one looked up the theme's pack 1 and relabelled the bar
         with it: a stamp page showing "1 T-shirt". A pack name only means
         something where a bundle builder exists; everywhere else the bar keeps
         the product title Liquid rendered into it. */
      var bb = document.querySelector('bundle-builder');
      if (!bb || !packLabel || !window.KOLPPricing) return;
      var pack = window.KOLPPricing.getPack(d.pack);
      var tpl = bb.dataset.i18nPackDefaultName || '__QTY__-Pack';
      packLabel.textContent = pack ? pack.name : tpl.replace('__QTY__', d.pack);
    });
    KOLP.bus.on('builder:btnstate', function (d) {
      var b = sticky.querySelector('[data-sticky-cta]');
      if (b) b.dataset.state = d.state;
    });
  }

  /* ---- size guide modal --------------------------------------- */
  var sizeModal = $('[data-size-guide-modal]');
  if (sizeModal) {
    var relS;
    var openSG = function () {
      sizeModal.classList.add('is-open');
      document.body.classList.add('no-scroll');
      relS = KOLP.trapFocus(sizeModal);
      var c = sizeModal.querySelector('[data-sg-close]');
      c && c.focus();
    };
    var closeSG = function () {
      sizeModal.classList.remove('is-open');
      document.body.classList.remove('no-scroll');
      relS && relS();
    };
    KOLP.bus.on('sizeguide:open', openSG);
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-size-guide]')) { e.preventDefault(); openSG(); }
      if (e.target.closest('[data-sg-close]') || e.target === sizeModal) closeSG();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sizeModal.classList.contains('is-open')) closeSG();
    });
  }

  /* ---- product gallery --------------------------------------- */
  $$('[data-gallery]').forEach(function (gallery) {
    var track = gallery.querySelector('.gallery__track');
    var slides = $$('.gallery__slide', gallery);
    var thumbs = $$('.gallery__thumb', gallery);

    /* Scroll ONLY the horizontal track — never scrollIntoView(), which also
       scrolls the page/window vertically and yanks the user up to the image. */
    function scrollToSlide(slide) {
      if (!track || !slide) return;
      // desktop grid layout: all images visible, nothing to scroll
      if (track.scrollWidth <= track.clientWidth + 4) return;
      var delta = slide.getBoundingClientRect().left - track.getBoundingClientRect().left;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollBy({ left: delta, behavior: reduce ? 'auto' : 'smooth' });
    }
    function goto(i) {
      if (!slides[i]) return;
      scrollToSlide(slides[i]);
      thumbs.forEach(function (t, ti) { t.setAttribute('aria-current', ti === i ? 'true' : 'false'); });
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goto(i); }); });

    if (track) {
      track.addEventListener('scroll', KOLP.debounce(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        thumbs.forEach(function (t, ti) { t.setAttribute('aria-current', ti === i ? 'true' : 'false'); });
      }, 80), { passive: true });
    }

    // sync to colour changes (bundle builder or standard PDP)
    KOLP.bus.on('builder:color', function (d) {
      if (!d || !d.color) return;
      var needle = d.color.toLowerCase();
      var slide = slides.find(function (s) {
        return (s.dataset.color || '').toLowerCase().indexOf(needle) !== -1;
      });
      if (slide) {
        scrollToSlide(slide);
        var i = slides.indexOf(slide);
        thumbs.forEach(function (t, ti) { t.setAttribute('aria-current', ti === i ? 'true' : 'false'); });
      }
    });
  });

  /* ---- product carousel ------------------------------------- */
  $$('[data-carousel]').forEach(function (carousel) {
    var track = carousel.querySelector('[data-carousel-track]');
    if (!track) return;
    var prev = carousel.querySelector('[data-carousel-prev]');
    var next = carousel.querySelector('[data-carousel-next]');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function step() {
      var item = track.querySelector('.carousel__item');
      var w = item ? item.getBoundingClientRect().width : track.clientWidth * 0.8;
      var cs = getComputedStyle(track);
      var gap = parseFloat(cs.columnGap || cs.gap) || 16;
      return (w + gap) * (window.innerWidth >= 1000 ? 2 : 1);
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth - 2;
      carousel.classList.toggle('carousel--static', max <= 0);
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
    }
    function nudge(dir) {
      track.scrollBy({ left: dir * step(), behavior: reduce ? 'auto' : 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { nudge(-1); });
    if (next) next.addEventListener('click', function () { nudge(1); });
    track.addEventListener('scroll', KOLP.debounce(update, 80), { passive: true });
    window.addEventListener('resize', KOLP.debounce(update, 150));
    update();
  });

  /* ---- PDP delivery estimate + order-cutoff countdown -------- */
  $$('[data-pdp-eta]').forEach(function (el) {
    var leadMin = parseInt(el.dataset.leadMin, 10) || 2;
    var leadMax = parseInt(el.dataset.leadMax, 10) || 5;
    var cutoff = parseInt(el.dataset.cutoffHour, 10);
    var dateEl = el.querySelector('[data-pdp-eta-date]');
    var cdEl = el.querySelector('[data-pdp-eta-cd]');
    var fmt = new Intl.DateTimeFormat(document.documentElement.lang || 'en', { weekday: 'short', day: 'numeric', month: 'short' });
    // Translated templates (rendered by Liquid with the {{ var }} tokens left
    // unresolved on purpose — see snippets/pdp-delivery.liquid) with plain
    // English fallbacks in case the markup predates these data attributes.
    var tDates = el.dataset.i18nDeliveryDates || 'Estimated delivery __FROM__ – __TO__.';
    var tCountdown = el.dataset.i18nDispatchCountdown || 'Order within __TIME__ for same-day dispatch.';
    var tHours = el.dataset.i18nHours || 'h';
    var tMinutes = el.dataset.i18nMinutes || 'm';
    var tSeconds = el.dataset.i18nSeconds || 's';

    function addBusinessDays(from, n) {
      var d = new Date(from);
      while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) n--; }
      return d;
    }
    function render() {
      var now = new Date();
      var beforeCutoff = !isNaN(cutoff) && now.getHours() < cutoff;
      // if past cutoff, orders ship next business day → shift the window by 1 day
      var base = beforeCutoff ? now : addBusinessDays(now, 1);
      if (dateEl) {
        dateEl.textContent = tDates
          .replace('__FROM__', fmt.format(addBusinessDays(base, leadMin)))
          .replace('__TO__', fmt.format(addBusinessDays(base, leadMax)));
      }
      if (cdEl && !isNaN(cutoff)) {
        if (beforeCutoff) {
          var end = new Date(now); end.setHours(cutoff, 0, 0, 0);
          var s = Math.max(0, Math.floor((end - now) / 1000));
          var h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
          var time = h + tHours + ' ' + m + tMinutes + ' ' + sec + tSeconds;
          cdEl.hidden = false;
          cdEl.textContent = tCountdown.replace('__TIME__', time);
        } else {
          cdEl.hidden = true;
        }
      }
    }
    render();
    setInterval(render, 1000);
  });

  /* ---- PDP "people viewing" (session-stable pseudo count) ---- */
  $$('[data-pdp-viewers]').forEach(function (el) {
    var min = parseInt(el.dataset.min, 10) || 8;
    var max = parseInt(el.dataset.max, 10) || 22;
    var textEl = el.querySelector('[data-pdp-viewers-text]');
    if (!textEl) return;
    var tpl = textEl.dataset.tpl || textEl.textContent;
    textEl.dataset.tpl = tpl;
    var key = 'kolp_viewers_' + (location.pathname || '');
    var n;
    try { n = parseInt(sessionStorage.getItem(key), 10); } catch (e) {}
    if (!n || n < min || n > max) {
      n = min + Math.floor(Math.random() * (max - min + 1));
      try { sessionStorage.setItem(key, String(n)); } catch (e) {}
    }
    function drift() {
      n = Math.min(max, Math.max(min, n + (Math.random() < 0.5 ? -1 : 1)));
      textEl.textContent = tpl.replace('{n}', n);
      try { sessionStorage.setItem(key, String(n)); } catch (e) {}
    }
    textEl.textContent = tpl.replace('{n}', n);
    setInterval(drift, 8000 + Math.random() * 7000);
  });

  /* ---- newsletter (Shopify handles the POST; we track intent) --- */
  $$('.newsletter__form, [data-newsletter-form]').forEach(function (form) {
    form.addEventListener('submit', function () {
      KOLP.analytics && KOLP.analytics.track('newsletter_signup', {});
    });
  });

  /* ---- cookie banner ---------------------------------------- */
  var banner = $('[data-cookie-banner]');
  if (banner) {
    var show = function () {
      if (KOLP.consent.needsBanner()) banner.classList.add('is-visible');
    };
    KOLP.consent.ready(function () {
      if (!KOLP.consent.needsBanner()) banner.classList.remove('is-visible');
    });
    setTimeout(show, 400);

    banner.querySelector('[data-cookie-accept]').addEventListener('click', function () {
      KOLP.consent.set({ analytics: true, marketing: true, preferences: true });
      banner.classList.remove('is-visible');
    });
    banner.querySelector('[data-cookie-reject]').addEventListener('click', function () {
      KOLP.consent.set({ analytics: false, marketing: false, preferences: false });
      banner.classList.remove('is-visible');
    });
    var prefs = banner.querySelector('[data-cookie-prefs]');
    if (prefs) prefs.addEventListener('click', function () {
      if (window.Shopify && window.Shopify.customerPrivacy && window.privacyBanner) {
        try { window.privacyBanner.showPreferences(); return; } catch (e) {}
      }
      // fallback: accept analytics only
      KOLP.consent.set({ analytics: true, marketing: false, preferences: true });
      banner.classList.remove('is-visible');
    });
  }

  /* ---- "Cookie preferences" re-opener (Shopify's native banner) -------
     Shown only where a consent choice can actually be made — i.e. once the
     Customer Privacy API is present. Lets visitors change or withdraw
     consent after the native banner has been dismissed. */
  var prefsTriggers = $$('[data-cookie-prefs]').filter(function (el) {
    return !el.closest('[data-cookie-banner]');
  });
  if (prefsTriggers.length) {
    var syncPrefsVisibility = function () {
      var ready = !!(window.Shopify && window.Shopify.customerPrivacy);
      prefsTriggers.forEach(function (el) { el.hidden = !ready; });
    };
    document.addEventListener('shopifyCustomerPrivacyApiLoaded', syncPrefsVisibility);
    window.addEventListener('load', syncPrefsVisibility);
    setTimeout(syncPrefsVisibility, 800);
    prefsTriggers.forEach(function (el) {
      el.addEventListener('click', function () {
        if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
          try { window.privacyBanner.showPreferences(); return; } catch (e) {}
        }
        if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.setTrackingConsent === 'function') {
          try { window.Shopify.customerPrivacy.setTrackingConsent(); } catch (e) {}
        }
      });
    });
  }

  /* ---- CTA smooth-scroll to purchase ------------------------ */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href="#build"], [data-scroll-to-build]');
    if (!a) return;
    var target = $('[data-purchase-section]');
    if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  });
})();
